module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/HomepageHero-8bbfdfd397756a86052eca4b57d73eed.png";